export function shouldClearProactiveCifFiles(oldTargetGroup, newTargetGroup) {
  const leavesCifList = oldTargetGroup === 'CIF' && newTargetGroup !== 'CIF';
  const entersCifListFromExceptCif = oldTargetGroup === 'ExceptCIF' && newTargetGroup === 'CIF';

  return leavesCifList || entersCifListFromExceptCif;
}
export function getProactiveCifClearMessage(oldTargetGroup, newTargetGroup) {
  if (oldTargetGroup === 'CIF' && newTargetGroup === 'ExceptCIF') {
    return 'Except CIF blocks the CIFs in its file, the opposite of CIF List. Please upload the file of CIFs to block.';
  }

  if (oldTargetGroup === 'ExceptCIF' && newTargetGroup === 'CIF') {
    return 'CIF List targets the CIFs in its file, the opposite of Except CIF. Please upload the file of CIFs to target.';
  }

  return 'The uploaded CIF file has been cleared because the Target Group changed from CIF List.';
}
